import { inject, Signal } from '@angular/core';
import { ServiceProviderName } from '../../model/service-provider-name';
import { TenantsFacadeService } from '../../store/tenants/tenants.facade.service';

export const injectServiceProviderName = (): Signal<ServiceProviderName> =>
  inject(TenantsFacadeService).serviceProviderName;
